// Angular Files
import { Component, NgModule, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material Files
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    selector: 'teller-online-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    host: {
        class: 'notification-content'
    },
    standalone: false
})
export class TellerOnlineNotificationComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: TellerOnlineNotificationData,
        public snackBarRef: MatSnackBarRef<TellerOnlineNotificationComponent>
    ) {}

    public onClick_dismiss(): void {
        this.snackBarRef.dismissWithAction();
    }
}

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatSnackBarModule
    ],
    declarations: [TellerOnlineNotificationComponent],
    exports: [TellerOnlineNotificationComponent]
})
export class TellerOnlineNotificationModule { }

export interface TellerOnlineNotificationData {
    message: string;
    dismissLabel?: string;
}
